<template>
    <div>
        <div
            class="tsoft-notification"
            @click="isSidebarOpen = !isSidebarOpen"
        >
            <i
                :class='`bx bxs-bell${calcNotifications.length > 0 ?
                    "-ring bx-tada text-orange" : ""}`'
            ></i>
            <div
                v-if="calcNotificationFinance.length > 0"
                class="tsoft-notification_badge-finance"
            >
                <b-badge
                    pill
                    variant="light"
                >
                    {{ calcNotificationFinance.length }}
                </b-badge>
            </div>
            <div
                v-if="calcNotificationsOrder.length > 0"
                class="tsoft-notification_badge-order"
            >
                <b-badge
                    pill
                    variant="light"
                >
                    {{ calcNotificationsOrder.length }}
                </b-badge>
            </div>
            <div
                v-if="calcNotificationsSystem.length > 0"
                class="tsoft-notification_badge-task"
            >
                <b-badge
                    pill
                    variant="blue"
                >
                    {{ calcNotificationsSystem.length }}
                </b-badge>
            </div>
        </div>
        <b-sidebar
            id="notification-sidebar"
            v-model="isSidebarOpen"
            right
            backdrop
            width="30em"
        >
            <template #title>
                <div class="title-sidebar">
                    <strong class="ml-2">Уведомления</strong>
                </div>
            </template>
            <div>
                <div class="d-flex">
                    <b-form-checkbox
                        id="checkbox-notification-all"
                        v-model="changeAllChecked"
                        name="checkbox-send-notification"
                        :value="true"
                        :unchecked-value="false"
                        class="d-inline font-size-12 mr-2"
                        @change="checkAllNotification($event)"
                    />
                    <b-form-radio-group
                        id="btn-radios-1"
                        v-model="selected"
                        :options="options"
                        name="radios-btn-default"
                        button-variant="outline-primary"
                        class="w-100 border-5 filter-value-notification mb-3"
                        buttons
                        @change="updateChecked"
                    />
                </div>
                <div v-if="selected == 'all' || selected == 'system' || selected == 'finance' || selected == 'order'">
                    <div
                        v-for="(notify, index) in calcNotifications"
                        :key="index"
                        class="d-flex"
                    >
                        <b-form-checkbox
                            :id="`checkbox-notification-${index}`"
                            v-model="notify.checked"
                            name="checkbox-send-notification"
                            :value="true"
                            :unchecked-value="false"
                            class="d-inline font-size-12 mr-2"
                            style="margin-top: -4px;"
                            @change="updateSelected"
                        />

                        <div
                            :class="
                                `${notify.data.parameters.invoice_type == 'outgoing' ?'shadow-blue' : ''}
                                ${notify.data.parameters.invoice_type == 'incoming' ? 'shadow-red' : ''}
                                notification_card mb-3`
                            "
                        >
                            <div>
                                <span
                                    class="notify-message"
                                    v-html="notify.data.message"
                                />
                                <div class="d-flex justify-content-between mt-2">
                                    <div class="mr-2 time-special">
                                        <small>Время: {{ formatDateTime(notify.created_at) }}</small>
                                    </div>
                                    <template v-if="notify.data.parameters.link">
                                        <span
                                            v-if="notify.data.parameters.link.includes('order')"
                                            class="sidebar-link sidebar-link-special"
                                            @click="openOrderSidebar(getNumberFromString(notify.data.parameters.link), getParamFromString(notify.data.parameters.link, 'edit-order'), getParamFromString(notify.data.parameters.link), 'tab-order')"
                                        >{{ notify.data.parameters.linkText || 'Открыть' }}</span>

                                        <span
                                            v-if="notify.data.parameters.link.includes('finance')"
                                            class="sidebar-link sidebar-link-special"
                                            @click="openFinanceSidebar(getNumberFromString(notify.data.parameters.link))"
                                        >{{ notify.data.parameters.linkText || 'Открыть' }}</span>

                                        <span
                                            v-if="notify.data.parameters.link.includes('system')"
                                            class="sidebar-link sidebar-link-special"
                                            @click="openTaskSidebar({id: getNumberFromString(notify.data.message)})"
                                        >Открыть задачу</span>

                                        <span
                                            v-if="notify.data.parameters.link.includes('email-tracking')"
                                            class="sidebar-link sidebar-link-special"
                                            @click="openEmailTrackingSidebar(getParamFromString(notify.data.parameters.link, 'email-tracking'))"
                                        >Открыть переписку</span>
                                    </template>
                                    <template v-else>
                                        <span
                                            v-if="notify.data.parameters.type === 'system'"
                                            class="sidebar-link sidebar-link-special"
                                            @click="openTaskSidebar({id: getNumberFromString(notify.data.message)})"
                                        >Открыть задачу</span>

                                        <span
                                            v-if="notify.data.parameters.type === 'finance'"
                                            class="sidebar-link sidebar-link-special"
                                            @click="openFinanceSidebar(getNumberFromString(notify.data.message))"
                                        >Открыть счет</span>
                                    </template>
                                </div>
                            </div>
                            <div class="close-notification">
                                <b-icon
                                    icon="x"
                                    scale="1.7"
                                    variant="secondary"
                                    title="Закрыть"
                                    style="cursor:pointer;"
                                    :animation="notify.read_at ? 'spin-reverse' : ''"
                                    @click="actionCloseNotification(index, notify.id)"
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="calcNotifications.length === 0"
                        class="text-center pb-3 pt-2"
                    >
                        <span class="text-secondary text-uppercase">Нет уведомлений</span>
                    </div>
                </div>
            </div>
            <template
                v-if="calcNotifications.length > 0"
                #footer
            >
                <div class="footer-sidebar">
                    <button
                        v-if="isNotificationHasChecked"
                        class="btn btn-outline-secondary w-100"
                        @click="actionCloseAllNotificationChecked"
                    >
                        Прочитать выделенные
                    </button>
                    <button
                        v-if="!isNotificationHasChecked"
                        class="btn btn-outline-secondary w-100"
                        @click="actionCloseAllNotification"
                    >
                        Прочитать всё
                    </button>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { API_POST_NOTIFICATIONS_READ } from '@/constants';
    import { openOrderSidebar } from '@/mixins/openOrderSidebar';
    import { openFinanceSidebar } from '@/mixins/openFinanceSidebar';
    import { openTaskSidebar } from '@/mixins/openTaskSidebar';
    import { openEmailTrackingSidebar } from '@/mixins/openEmailTrackingSidebar';

    export default {
        mixins: [
            openOrderSidebar,
            openFinanceSidebar,
            openTaskSidebar,
            openEmailTrackingSidebar
        ],
        data() {
            return {
                selected: 'all',
                options: [
                    { text: 'Все уведомления', value: 'all' },
                    // { text: 'Поставки', value: 'order' },
                    // { text: 'Финансы', value: 'finance' },
                    // { text: 'Системные', value: 'system' }
                ],
                isFirstLoad: true,
                changeAllChecked: false,
                isSidebarOpen: false,
            };
        },
        computed: {
            ...mapGetters('settings', ['app_focus']),
            ...mapGetters('auth', ['currentUser', 'isAuthenticated']),
            notifications() {
                return this.$store.getters.NOTIFICATIONS;
            },
            calcNotifications() {
                if (this.selected !== 'all') {
                    return this.notifications.filter(i => {
                        if (i.data && i.data.parameters && i.data.parameters.type && i.data.parameters.type === this.selected) {
                            return i;
                        }
                    });
                }
                return this.notifications.filter(i => {
                    if (i.data && i.data.parameters && i.data.parameters.type) {
                        return i;
                    }
                });
            },
            calcNotificationsSystem() {
                return this.notifications.filter(i => {
                    if (i.data && i.data.parameters && i.data.parameters.type && i.data.parameters.type === 'system') {
                        return i;
                    }
                });
            },
            calcNotificationsOrder() {
                return this.notifications.filter(i => {
                    if (i.data && i.data.parameters && i.data.parameters.type && i.data.parameters.type === 'order') {
                        return i;
                    }
                });
            },
            calcNotificationFinance() {
                return this.notifications.filter(i => {
                    if (i.data && i.data.parameters && i.data.parameters.type && i.data.parameters.type === 'finance') {
                        return i;
                    }
                });
            },
            isNotificationHasChecked() {
                return this.calcNotifications.some(i => i.checked);
            },
        },
        watch: {
            notifications(newNotifications, oldNotifications) {
                if (newNotifications.length > 0) {
                    let isBellType = false;

                    if (newNotifications[newNotifications.length - 1].data.parameters && newNotifications[newNotifications.length - 1].data.parameters.place) {
                        try {
                            isBellType = newNotifications[newNotifications.length - 1].data.parameters.place.includes('bell');
                        } catch (error) {
                            console.error('Problems with finding .place', error);
                        }
                    }

                    if (newNotifications.length > oldNotifications.length && !this.isFirstLoad && isBellType) {
                        if (!this.app_focus) {
                            const favicon = document.getElementById('favicon');
                            favicon.href = 'favicon-notification.svg';
                        }
                        this.playNotificationBell();
                    }

                    this.isFirstLoad = false;
                }
            },

            isSidebarOpen() {
                if (!this.isSidebarOpen) {
                    this.updateChecked();
                }
            }
        },
        mounted() {
            this.$store.dispatch('GET_NOTIFICATIONS');
            this.setUnreadInterval();
        },
        methods: {
            async actionCloseNotification(index, id) {
                this.calcNotifications[index].read_at = 'reading';

                await api.call('post', `${API_POST_NOTIFICATIONS_READ}/${id}`)
                    .then(() => this.$store.commit('READ_NOTIFICATIONS', id))
                    .catch(er => {
                        console.log(er);
                    });
            },
            actionCloseAllNotification() {
                this.calcNotifications.forEach(async (notify, index) => {
                    await this.actionCloseNotification(index, notify.id);
                });
            },
            actionCloseAllNotificationChecked() {
                this.calcNotifications.forEach(async (notify, index) => {
                    if (notify.checked) {
                        await this.actionCloseNotification(index, notify.id);
                    }
                });
            },
            formatDateTime(dateString) {
                if (!dateString) {
                    return dateString;
                }
                let formattedDate = (new Date(dateString)).toLocaleDateString();
                let formattedTime = (new Date(dateString)).toLocaleTimeString();
                let formattedTimeArray = formattedTime.split(':');

                return formattedDate + ' ' + formattedTimeArray[0] + ':' + formattedTimeArray[1];
            },

            playNotificationBell() {
                const audio = new Audio('sounds/notificationBell.mp3');
                audio.volume = .4;
                audio.play();
            },

            getNumberFromString(str) {
                return str = str.replace(/\D/g, ' ').trim().split(' ')[0];
            },

            getParamFromString(str, param = 'tab-order') {
                const params = new URLSearchParams(str);
                return params.get(param);
            },

            updateSelected() {
                const temp = this.selected;
                this.selected = null;
                this.selected = temp;
            },

            updateChecked() {
                this.changeAllChecked = false;
                this.updateSelected();
                this.calcNotifications.forEach(i => i.checked = false);
            },

            checkAllNotification(e) {
                this.updateSelected();
                this.calcNotifications.forEach(i => i.checked = e);
            },

            setUnreadInterval() {
                setInterval(() => {
                    if (this.isAuthenticated && !this.isNotificationHasChecked) {
                        this.$store.dispatch('GET_NOTIFICATIONS');
                    }
                }, 30000);
            },
        }
    };
</script>